import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { useGetVehicleInfo } from "../../../queries/useGetVehicleInfo";
import { useSearchWheelsByVehicle } from "../../../queries/useSearchWheelsByVehicle";
import { VehicleHeader } from "../../VehicleHeader/VehicleHeader";
import { Visualizer } from "../../Visualizer/Visualizer";
import { shouldRenderVisualizer } from "../../Visualizer/shouldRenderVisualizer";
import { WheelList } from "./WheelList";
import { WheelStatusbar } from "./WheelStatusbar";

export const Wheels: FunctionComponent = () => {
  const { data: vehicleInfo } = useGetVehicleInfo();
  const { data: results, isLoading } = useSearchWheelsByVehicle();
  const hasVisualizer = shouldRenderVisualizer(
    vehicleInfo,
    results?.allParts.length,
  );
  return (
    <>
      {!hasVisualizer && (
        <>
          <VehicleHeader className="mt-10" />
          <WheelStatusbar
            className={clsx(hasVisualizer && "mt-2")}
            isLoading={isLoading}
          />
        </>
      )}
      {hasVisualizer && (
        <Visualizer
          controls={
            <WheelStatusbar
              className={clsx(hasVisualizer && "mt-2")}
              isLoading={isLoading}
            />
          }
          className="mt-4"
          parts={results?.filteredParts || null}
          vehicleInfo={vehicleInfo || null}
        />
      )}
      <WheelList
        hasVisualizer={hasVisualizer}
        parts={results?.filteredParts}
        vehicleInfo={vehicleInfo}
      />
    </>
  );
};
